// The redesign is now the default, served IN PLACE at this existing URL (no /nova, no redirect).
// Content mirrors pages/nova/sign-up.tsx; the legacy page component is not deleted, just no longer mounted here.
import getServerSidePropsPage from 'root/src/client/util/getServerSidePropsPage'
import { RedesignSignUpPage } from 'root/src/client/v2/_pages/auth/redesign/RedesignSignUpPage'

export const getServerSideProps = getServerSidePropsPage

export default RedesignSignUpPage
